import {
    GET_VEHICLE_CAPACITY,
    SET_VEHICLE_CAPACITY
} from "./VehicleCapacityType"

const getVehicleCapacity = (val : any) => ({
    type: GET_VEHICLE_CAPACITY,
    val
});

const setVehicleCapacity = (vehicleCapacityDropDown: any) => ({
    type: SET_VEHICLE_CAPACITY,
    vehicleCapacityDropDown: vehicleCapacityDropDown
});

export {
    getVehicleCapacity,
    setVehicleCapacity
}
